import { Component, OnInit } from '@angular/core';
import { AdminService } from 'src/app/services/Admin/admin.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import * as moment from 'moment'

@Component({
  selector: 'app-login-report',
  templateUrl: './login-report.component.html',
  styleUrls: ['./login-report.component.css']
})
export class LoginReportComponent implements OnInit {

  LoginReportList=[];
  
  constructor(private adminservice: AdminService, private lookupservice: LookupService,
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }

    LoginReportModel = {
      LoginId: '',     
  }

  Clear() {
      this.FilterModel.LoginId = "";
      this.FilterModel.FromDate = moment(new Date()).format('DD-MMM-YYYY');
      this.FilterModel.ToDate=  moment(new Date()).format('DD-MMM-YYYY');
     
      this.GetLoginReport();
  };


  FilterModel = {
      LoginId: '',
      FromDate: moment(new Date()).format('DD-MMM-YYYY'),
      ToDate: moment(new Date()).format('DD-MMM-YYYY'),
      UserLoginId: 0    
  }

  GetLoginReport() {
      this.spinnerService.show();
      this.FilterModel.FromDate =this.FilterModel.FromDate!=null?moment(this.FilterModel.FromDate).format('DD-MMM-YYYY'):'';
      this.FilterModel.ToDate =this.FilterModel.ToDate!=null?moment(this.FilterModel.ToDate).format('DD-MMM-YYYY'):'';
     
      this.adminservice.GetLoginReport(JSON.stringify(this.FilterModel)).subscribe((data: any) => {
          this.LoginReportList = data.LoginReportList;
          this.spinnerService.hide();
        
      });
  };


  ngOnInit() {
  }

}
